// This plugin configures $fetch for development environments with self-signed certificates
export default defineNuxtPlugin(() => {
  // Note: In client-side JavaScript, we cannot bypass SSL certificate validation
  // The browser enforces SSL certificate validation for security reasons
  // 
  // For development with self-signed certificates, you have a few options:
  // 1. Add the certificate to your system's trusted certificates
  // 2. Use Chrome with --ignore-certificate-errors flag (not recommended)
  // 3. Click through the browser warning to accept the certificate
  // 4. Use a proper certificate from Let's Encrypt or similar
  
  // For now, let's at least log when SSL errors might be occurring
  if (process.dev) {
    const config = useRuntimeConfig()
    const wpApiUrl = config.public.wpApiBase?.replace('/wp-json', '') || 'https://altracare.dev:8890'
    console.log('Development mode: SSL certificate errors may occur with self-signed certificates')
    console.log(`If you see network errors, try accessing ${wpApiUrl} directly and accept the certificate`)
  }
})